<!-- Kopfzeile -->
<div class="one-row">
    <h1>Beleg {{ heimtierBeleg?.beleg_nr }}</h1>
    <div *ngIf="heimtierBeleg?.status_id === HeimtierBelegStatus.ABGESCHLOSSEN" style="margin: 0 0 16px 24px">
        <span class="phito-status-badge">{{ heimtierBeleg?.status }}</span>
    </div>
    <span class="spacer"></span>
    <div class="header-details">
        <mat-form-field>
            <mat-label>Besuchsdatum</mat-label>
            <input
                [disabled]="heimtierBeleg?.status_id === 223"
                [formControl]="besuchsdatumCtrl"
                [matDatepicker]="picker"
                matInput
            />
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Behandlung Start</mat-label>
            <input [formControl]="behandlungStartCtrl" matInput type="time" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Behandlung Ende</mat-label>
            <input [formControl]="behandlungEndeCtrl" matInput type="time" />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Tierarzt</mat-label>
            <mat-select [disabled]="heimtierBeleg?.status_id === 223" [formControl]="arztCtrl">
                <mat-option *ngFor="let arzt of aerzte" [value]="arzt">
                    {{ arzt?.vorname }} {{ arzt?.nachname }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <button
        (click)="abschliessen()"
        *ngIf="heimtierBeleg?.status_id === 221"
        [disabled]="disabled()"
        class="button_send"
        color="primary"
        mat-flat-button
        >Abschließen
    </button>
    <button
        (click)="rechnungErstellen()"
        *ngIf="heimtierBeleg?.status_id === 222"
        [disabled]="disabled()"
        class="button_send"
        color="primary"
        mat-flat-button
        >Rechnung erstellen
    </button>
</div>

<!-- Besuchsdaten -->
<div class="one-row">
    <div style="align-self: flex-start; width: calc(100% - 200px)">
        <mat-tab-group
            (selectedTabChange)="onTabChange($event)"
            [(selectedIndex)]="selectedTabIndex"
            style="width: 100%"
        >
            <!-- Beleg -->
            <mat-tab label="Beleg">
                <kiene-besuchs-detail-beleg
                    (validationChange)="onBelegValidationChange($event)"
                    [heimtierBeleg]="heimtierBeleg"
                    (heimtierBelegChange)="setCurrentBeleg($event)"
                ></kiene-besuchs-detail-beleg>
            </mat-tab>
            <mat-tab label="Klinische Untersuchung">
                <kiene-besuchs-detail-untersuchung
                    [heimtierBeleg]="heimtierBeleg"
                    (heimtierChange)="setCurrentHeimtier($event)"
                    (heimtierBelegChange)="setCurrentBeleg($event)"
                ></kiene-besuchs-detail-untersuchung>
            </mat-tab>
            <mat-tab label="Leistungen/Medikamente">
                <kiene-leistungen
                    (tierChange)="setCurrentHeimtier($event)"
                    [(heimtierBeleg)]="heimtierBeleg"
                    (heimtierBelegChange)="setCurrentBeleg($event)"
                ></kiene-leistungen>
            </mat-tab>
            <!-- Rechnungen -->
            <mat-tab label="Letzte Rechnungen">
                <kiene-besuchs-detail-rechnungen [heimtierBeleg]="heimtierBeleg"></kiene-besuchs-detail-rechnungen>
            </mat-tab>
            <!-- Letzte Belege -->
            <mat-tab label="Letzte Belege">
                <kiene-besuchs-detail-letzte-belege
                    [heimtierBeleg]="heimtierBeleg"
                ></kiene-besuchs-detail-letzte-belege>
            </mat-tab>
        </mat-tab-group>
    </div>

    <span class="spacer"></span>

    <!-- Besuchsinformationen -->
    <div style="align-self: flex-start; width: 200px; margin-left: 24px">
        <kiene-heimtier-info [heimtier]="heimtier"></kiene-heimtier-info>
    </div>
</div>
